<template>
  <div id="cargos">
    <div class="row">
      <div class="col-xs-12">
        <h3 class="custom-subtitle">Cadastro de Cargos</h3>
      </div>
    </div>
    <div class="row">
      <input-vagas
        :cssClass="'col-xs-12'"
        :label="'Descrição do Cargo'"
        :class="['custom-font', { 'is-danger': errors.has('cargos') }]"
        :name="'cargos'"
        :error="errors.has('cargos') ? errors.first('cargos') : ''"
        v-model="model.descricao"
        v-validate="'required'"
      />
      <input-vagas
        :label="'Total de Vagas'"
        :class="['custom-font', { 'is-danger': errors.has('total') }]"
        :name="'total'"
        :error="errors.has('total') ? errors.first('total') : ''"
        v-model="model.vagas"
        v-validate="'required|numeric'"
      />
      <input-vagas
        :label="'Vagas PCD'"
        :class="['custom-font', { 'is-danger': errors.has('vagas_pcd') }]"
        :name="'vagas_pcd'"
        :error="errors.has('vagas_pcd') ? errors.first('vagas_pcd') : ''"
        v-model="model.vagas_pcd"
        v-validate="'required|numeric'"
      />
      <input-vagas
        :label="'Vagas Cotas'"
        :class="['custom-font', { 'is-danger': errors.has('vagas_cotas') }]"
        :name="'vagas_cotas'"
        :error="errors.has('vagas_cotas') ? errors.first('vagas_cotas') : ''"
        v-model="model.vagas_cotas"
        v-validate="'required|numeric'"
      />
      <input-vagas
        :label="'Vagas QP'"
        :class="['custom-font', { 'is-danger': errors.has('vagas_qp') }]"
        :name="'vagas_qp'"
        :error="errors.has('vagas_qp') ? errors.first('vagas_qp') : ''"
        v-model="model.vagas_QP"
        v-validate="'numeric'"
      />
      <div class="form-group col-xs-12 col-sm-6 col-md-3">
        <label class="custom-font">Homologação</label>
        <datepicker
          v-model="model.data_homologacao"
          name="data_homologacao"
          ref="data_homologacao"
        ></datepicker>
      </div>
      <div class="form-group col-xs-12 col-sm-6 col-md-3">
        <label class="custom-font">Validade</label>
        <datepicker
          v-model="model.data_validade"
          name="data_validade"
          ref="data_validade"
        ></datepicker>
      </div>
      <div class="col-xs-12 form-group">
        <label class="custom-font">Observação</label>
        <textarea
          class="form-control"
          v-model="model.observacao_validade"
        ></textarea>
      </div>
      <div class="col-xs-12 form-group">
        <button class="btn btn-default" :disabled="isLoading" @click="salvar()">
          <font-awesome-icon v-if="isLoading" :icon="'spinner'" spin />
          <font-awesome-icon v-else :icon="model.id ? 'save' : 'plus'" />
          {{ model.id ? 'Salvar' : 'Adicionar' }}
        </button>
        <button
          class="btn btn-default"
          v-if="model.id"
          :disabled="isLoading"
          @click="homologarTodos()"
        >
          <font-awesome-icon v-if="isLoading" :icon="'spinner'" spin />
          <font-awesome-icon v-else :icon="'save'" />
          Homologar Todos
        </button>
      </div>
    </div>
    <div class="row">
      <div class="col-xs-12">
        <data-table
          ref="vuetable"
          :dados="cargos"
          :fields="fields"
          :carregando="isLoading"
        >
          <template slot="rowrender" slot-scope="props">
            <button
              class="btn btn-success"
              @click="selecionarCargo(props.rowData)"
            >
              <font-awesome-icon :icon="'edit'" />
              <span class="sr-only">Editar</span>
            </button>
            <button class="btn btn-danger" @click="excluir(props.rowData)">
              <font-awesome-icon :icon="'trash-alt'" />
              <span class="sr-only">Excluir</span>
            </button>
          </template>
        </data-table>
      </div>
    </div>
  </div>
</template>

<style scoped>
.custom-subtitle {
  color: #00615c;
}

.custom-font {
  font-size: 16px;
  color: #00615c;
}

.custom-font.is-danger {
  color: #990000;
}
</style>

<script>
import { request } from '@/request'
import Message from './MensagemErro'
import DataTable from '@/components/common/NoApiTable'
import Datepicker from '@/components/common/Datepicker'
import InputVagas from './InputVagas.vue'
import { scrollToElement, toDate } from '@/utils'

export default {
  inject: ['showConfirm'],
  components: {
    Message,
    InputVagas,
    DataTable,
    Datepicker
  },
  props: {
    edital_id: {
      type: Number,
      required: true
    },
    numero: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      isLoading: false,
      cargos: [],
      listaCargos: [],
      model: {
        id: null,
        edital_id: null,
        descricao: '',
        vagas: '0',
        vagas_pcd: '0',
        vagas_cotas: '0',
        vagas_QP: '0',
        data_homologacao: '',
        data_validade: '',
        observacao_validade: ''
      },
      fields: [
        {
          name: 'descricao',
          title: 'Descrição'
        },
        {
          name: 'vagas',
          title: 'Vagas'
        },
        {
          name: 'vagas_pcd',
          title: 'Vagas PCD'
        },
        {
          name: 'vagas_cotas',
          title: 'Vagas Cotas'
        },
        {
          name: 'vagas_QP',
          title: 'Vagas QP'
        },
        {
          name: '__slot:actions',
          title: 'Visualizar',
          titleClass: 'text-center',
          dataClass: 'text-center'
        }
      ]
    }
  },
  created() {
    this.model.edital_id = this.edital_id
    this.listarCargosEdital()
  },
  computed: {},
  methods: {
    homologarTodos() {
      const { data_homologacao, edital_id } = this.model

      if (!data_homologacao) {
        this.$toastr.e('Selecione uma data de homologação!')
        return
      }

      const config = {
        title: 'Alerta',
        question: true,
        yes: () => {
          this.handleLoading()
          setTimeout(() => {
            this.handleLoading()
          }, 2000)
          request
            .post('edital/homologar-todos', {
              id: edital_id,
              data_homologacao: this.formatarData(data_homologacao)
            })
            .then(response => {
              this.$toastr.s('Cargos homologados com sucesso')
              this.listarCargosEdital()
            })
            .catch(error => {
              this.$toastr.e(
                'Houve um erro ao homologar os cargos, tente novamente e, se persistir o erro, entre em contato com o administrador.'
              )
              console.log(error.response.data)
            })
        }
      }
      this.showConfirm(
        `Deseja homologar todos os cargos deste edital com a mesma data (${data_homologacao.toLocaleDateString()})?`,
        config
      )
    },
    selecionarCargo(item) {
      const { data_homologacao, data_validade } = item
      this.model = {
        ...item,
        data_homologacao: data_homologacao ? toDate(data_homologacao) : '',
        data_validade: data_validade ? toDate(data_validade) : ''
      }
      scrollToElement('cargos')
    },
    excluir(data) {
      var config = {
        title: 'Alerta',
        question: true,
        yes: () => {
          request
            .delete(`cargo/${data.id}`)
            .then(response => {
              this.$toastr.s('Cargo excluído com sucesso')
              this.listarCargosEdital()
            })
            .catch(error => {
              this.$toastr.e(
                'Houve um erro ao excluir o cargo, tente novamente e, se persistir o erro, entre em contato com o administrador.'
              )
            })
        }
      }
      this.showConfirm(
        'Deseja realmente deletar este cargo? Todos os habilitados atribuidos a ele também serão excluídos.',
        config
      )
    },
    formatarData(item) {
      if (item) {
        return item.toISOString().split('T')[0]
      }
      return ''
    },
    salvar() {
      this.handleLoading()
      this.$validator.validateAll().then(result => {
        if (!result) {
          this.handleLoading()
          this.$toastr.e(this.$validator.errors.items[0].msg)
          return
        }

        const obj = { ...this.model }

        obj.data_homologacao = this.formatarData(obj.data_homologacao)
        obj.data_validade = this.formatarData(obj.data_validade)

        const { id } = obj

        if (id) {
          request
            .put(`cargo/${id}`, obj)
            .then(response => this.$toastr.s('Cargo salvo com sucesso.'))
            .catch(error =>
              this.$toastr.e(
                'Houve um erro ao salvar o cargo, verifique as informações e tente novamente.'
              )
            )
            .finally(() => {
              this.handleLoading()
              this.listarCargosEdital()
              this.limparCampos()
            })
        } else {
          request
            .post('cargo', obj)
            .then(response => this.$toastr.s('Cargo inserido com sucesso.'))
            .catch(error =>
              this.$toastr.e(
                'Houve um erro ao salvar o edital, verifique as informações e tente novamente.'
              )
            )
            .finally(() => {
              this.handleLoading()
              this.listarCargosEdital()
              this.limparCampos()
            })
        }
      })
    },
    handleLoading() {
      this.isLoading = !this.isLoading
    },
    listarCargosEdital() {
      request
        .get('cargo', { params: { nr_edital: this.numero } })
        .then(response => {
          this.cargos = response.data
        })
        .catch(error => {
          console.log(error.response)
        })
    },
    limparCampos() {
      this.model = {
        ...this.model,
        id: null,
        descricao: '',
        vagas: '0',
        vagas_pcd: '0',
        vagas_cotas: '0',
        vagas_QP: '0',
        data_homologacao: '',
        data_validade: '',
        observacao_validade: ''
      }
    }
  }
}
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/admin/concursos/edital/Cargos.vue